import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { FilterParams } from '@synergy/models';

import { ArticleDto } from '../models/dto/article-dto';
import { ArticleListItemDto } from '../models/dto/article-list-item-dto';
import { SearchOrigin } from '../models/search-origin';
import { SearchResultCounts } from '../models/search-result-counts';

export class ArticlesApi {
    constructor(protected baseUrl: string) {}

    public getArticleOffers = (
        searchParams?: URLSearchParams
    ): Promise<ApiResult<PaginatedResponse<ArticleListItemDto>>> => {
        const params = searchParams ?? new URLSearchParams();
        params.set(FilterParams.PageSize, '15');
        params.set(FilterParams.SpecialPrice, 'true');
        params.set(FilterParams.Randomized, 'true');
        return safeRequest(
            () => request.get(`${this.baseUrl}/products`, { params }),
            response => response.data
        );
    };

    public getArticlesSearch = (
        searchParams: URLSearchParams,
        isSearchHistory?: boolean,
        origin?: SearchOrigin,
        pageSize = 30
    ): Promise<ApiResult<PaginatedResponse<ArticleListItemDto, SearchResultCounts>>> => {
        searchParams.set(FilterParams.PageSize, pageSize.toString());
        if (isSearchHistory) {
            searchParams.set('history', 'true');
        }
        // The same endpoint answers a typed search, a filter change, a page turn and
        // every keystroke in the autocomplete. Saying which it was is what keeps the
        // search quality figures meaningful.
        if (origin) {
            searchParams.set('origin', origin);
        }
        return safeRequest(
            () => request.get(`${this.baseUrl}/products`, { params: searchParams }),
            response => response.data
        );
    };

    public getArticleDetails = (id: number): Promise<ApiResult<ArticleDto>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/products/${id}`),
            response => response.data
        );
}
